import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { LabelComponent } from './label.component';


@NgModule({
  declarations: [LabelComponent],
  exports: [LabelComponent],
  imports: [
    CommonModule,
    IonicModule,
  ]
})
export class LabelModule { }
